export const clearBrowserHistory = (): void => {
    try {
        // Remove URL parameters and clear browser history
        const cleanUrl = window.location.pathname;

        // Replace current state to clear any previous history
        window.history.replaceState(null, '', cleanUrl);

        // Push current address multiple times to fill history stack and prevent back navigation
        window.history.pushState(null, '', cleanUrl);

    } catch (error) {
        console.error('Error clearing browser history:', error);
    }
};

